import {useApiCall} from "./useApiCall";
import {useProfileStore} from "../store/hooks";
import {useCallback} from "react";
import {IHistory} from "../interfaces/user/history/history";
import {IProfile} from '../interfaces/user/profile/profile'

export const useProfileApi = () => {
  const {api} = useApiCall();
  const profileStore = useProfileStore();
  const {profile} = profileStore

  const getProfile = useCallback(
    async (isLoaded?: boolean) => {
      const res: IProfile = await api.apiInstance.get('profile', isLoaded);
      profileStore.setProfile(res);
      return !!res
    },
    [api.apiInstance, profileStore]
  );

  const editProfile = useCallback(
    async (data: IProfile) => {
      const res: IHistory = await api.apiInstance.put('profile', data);
      profileStore.setProfile({...profile, ...data});
      return !!res
    },
    [api.apiInstance, profileStore, profile]
  );

  return {
    getProfile,
    editProfile
  }
}